// Generated by GitHub Copilot
import { createFileRoute } from '@tanstack/react-router'
import { PersonalPreferencesPanel } from '#components/domain/auth/user/shared/personal-preferences-panel.tsx'

export const Route = createFileRoute('/settings/user')({
  component: PersonalPreferencesPanel,
})
